import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import { useModel as _useModel, mergeModels as _mergeModels } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue";
var _hoisted_1 = {
  class: "body-div"
};
var _hoisted_2 = {
  class: "body-right"
};
var _hoisted_3 = {
  class: "body-right_title"
};
var _hoisted_4 = {
  class: "body-right_context"
};
var _hoisted_5 = {
  class: "body-right_show"
};
var _hoisted_6 = ["onClick"];
var _hoisted_7 = ["src"];
var _hoisted_8 = {
  class: "footer"
};
var _hoisted_9 = {
  class: "like-count"
};
import { ref, watch } from 'vue';
import { MessagePlugin } from 'tdesign-vue-next';
import { getMinFileType } from '@/views/stuSpaceInfo/SynthesisList/picture.js';
import preview from '@/components/FilePreview/Preview';
import { getWorkPageDetails, giveALike } from '@/api/spaceInfo.js';
export default {
  __name: 'FilePreviewDialog',
  props: /*@__PURE__*/_mergeModels({
    activityItem: {
      type: Object,
      default: function _default() {}
    }
  }, {
    "visible": {
      default: false
    },
    "visibleModifiers": {}
  }),
  emits: /*@__PURE__*/_mergeModels(['updateStar'], ["update:visible"]),
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emit = __emit;
    var visible = _useModel(__props, 'visible'); // 是否显示弹框
    var currentSize = ref(0); // 右边切换顺序
    var listData = ref({});
    var imageUrl = ref('');
    var getList = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(val) {
        var query, _yield$getWorkPageDet, data, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              imageUrl.value = '';
              _context.p = 1;
              query = {
                tableName: val.tableName
              };
              _context.n = 2;
              return getWorkPageDetails(val.id, query);
            case 2:
              _yield$getWorkPageDet = _context.v;
              data = _yield$getWorkPageDet.data;
              listData.value = data.data;
              imageUrl.value = data.data.workItems[0].fileUrl;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              MessagePlugin.error(_t.message || '获取数据失败');
            case 4:
              return _context.a(2);
          }
        }, _callee, null, [[1, 3]]);
      }));
      return function getList(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    var changeLike = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(val) {
        var opType, dynamicContentType, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              opType = val.isLike === 0 ? 1 : 0;
              dynamicContentType = props.isWhere === 'lesson' ? '2' : '0';
              _context2.n = 1;
              return giveALike(val.id, dynamicContentType, opType);
            case 1:
              MessagePlugin.success('操作成功');
              val.isLike ? val.isLike = 0 : val.isLike = 1;
              val.likeCount = val.isLike ? val.likeCount - 1 : val.likeCount + 1;
              emit('updateStar');
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              MessagePlugin.error('操作失败');
            case 3:
              return _context2.a(2);
          }
        }, _callee2, null, [[0, 2]]);
      }));
      return function changeLike(_x2) {
        return _ref3.apply(this, arguments);
      };
    }();

    // 切换左边切换
    var changeShowImg = function changeShowImg(item, index) {
      currentSize.value = index;
      imageUrl.value = item.fileUrl;
    };
    watch(function () {
      return props.activityItem;
    }, function (val) {
      if (val.id) {
        currentSize.value = 0;
        getList(val);
      }
    }, {
      immediate: true
    });
    return function (_ctx, _cache) {
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_dialog = _resolveComponent("t-dialog");
      return _openBlock(), _createBlock(_component_t_dialog, {
        visible: visible.value,
        "onUpdate:visible": _cache[1] || (_cache[1] = function ($event) {
          return visible.value = $event;
        }),
        header: "作品详情",
        width: "90vw",
        footer: false,
        class: "active-dialog",
        closeOnOverlayClick: ""
      }, {
        default: _withCtx(function () {
          var _listData$value;
          return [_createElementVNode("div", _hoisted_1, [_createVNode(_unref(preview), {
            path: imageUrl.value,
            class: "preview-box"
          }, null, 8, ["path"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(listData.value.title), 1), _createElementVNode("div", _hoisted_4, _toDisplayString(listData.value.description), 1), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_listData$value = listData.value) === null || _listData$value === void 0 ? void 0 : _listData$value.workItems, function (item, index) {
            return _openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(currentSize.value === index ? 'active' : ''),
              onClick: function onClick($event) {
                return changeShowImg(item, index);
              }
            }, [_createElementVNode("img", {
              src: _unref(getMinFileType)(item.fileTypeText) || item.fileUrl,
              alt: ""
            }, null, 8, _hoisted_7), item.fileType === 4 || item.fileType === 16 ? (_openBlock(), _createBlock(_component_svg_icon, {
              key: 0,
              name: "icon-rongqi-copy",
              size: 16,
              class: "pause"
            })) : _createCommentVNode("", true)], 10, _hoisted_6);
          }), 128))])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("span", {
            class: "like-box",
            onClick: _cache[0] || (_cache[0] = function ($event) {
              return changeLike(listData.value);
            })
          }, [_createVNode(_component_svg_icon, {
            name: listData.value.isLike === 0 ? 'red-star' : 'black-like',
            size: 13,
            class: "icon_love"
          }, null, 8, ["name"]), _createElementVNode("span", _hoisted_9, _toDisplayString(listData.value.likeCount || 0), 1)])])])];
        }),
        _: 1
      }, 8, ["visible"]);
    };
  }
};